import { FETCH_PRODUCT_FEEDBACKS } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const productFeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_FEEDBACKS:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default productFeedbackReducer;
